import React, {Component} from 'react';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableRowComponent from "./tableRow";
import Pagination from "./pagination";
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import {withStyles} from "@material-ui/core/styles";
import Colors from "../../helpers/constants/colors";
import MediaQuery from 'react-responsive';
import TableList from './Table/tableList';
import { DroppableComponent } from '../DragDrop/DroppableComponent';
import { useDragDrop } from '../DragDrop/useDragDrop';
import { DraggableComponent } from '../DragDrop/DraggableComponent';

const styles = theme => ({
    head: {
        // backgroundColor: Colors.CART_CIRCLE_RED
    },
    body: {
        // fontSize: 14,
    },
    table: {
        // color: Colors.FACEBOOK_BUTTON
    },
    headCell: {
        // color: Colors.WHITE
    }
});

class TableComponent extends Component{
    constructor(props) {
        super();
        this.state = {
            currentItems: props && props.rows.length ? props.rows : [],
        }
    }

    setCurrentItems = (items) => {
        this.setState({
            currentItems: items
        })
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.props.orderBy === property && this.props.order === 'desc') {
            order = 'asc';
        }

        this.props.onRequestSort({ order, orderBy });
    };

     onItemSwap = (previous: Array<Block>, next: Array<Block>, e) => {
            const oldWeights = previous.map(item => item.weight);
            const itemsToChange = [];
            next
              .forEach((item, index) => {
                  if (item.weight !== oldWeights[index]) {
                      item.weight = oldWeights[index];
                      itemsToChange.push({id: item.id, weight: item.weight})
                  }
              });
            this.props.updateProductsWeights({
              brandId: this.props.brandId,
              products: itemsToChange,
            })
        };

    render() {

        const { classes } = this.props;
        const {items, onDragEnd} = useDragDrop(this.onItemSwap, this.state.currentItems, this.setCurrentItems);

        return(
            <div className={classes.root}>
                <MediaQuery query="(max-device-width: 768px)">
                    <TableList
                        {...this.props}
                        classes={null}
                    />
                </MediaQuery>
                <MediaQuery query="(min-device-width: 769px)">
                    <Table
                        className={classes.table}
                        height={this.props.height}
                        style={{tableLayout: 'unset'}}
                    >
                        <TableHead className={classes.head}>
                            <TableRow >
                                {
                                    this.props.columns.map((column,index) => {
                                        return (
                                            <TableCell
                                                className={classes.headCell}
                                                key={index}
                                                tooltip={column}
                                                sortDirection={this.props.orderBy === index ? this.props.order : false}
                                            >
                                                {
                                                    this.props.isSortable ?
                                                        column.excludeFromSorting?
                                                            column.name:
                                                            <Tooltip
                                                                title="Sort"
                                                                placement={true? 'bottom-end' : 'bottom-start'}
                                                                enterDelay={300}
                                                            >
                                                                <TableSortLabel
                                                                    active={this.props.orderBy === index}
                                                                    direction={this.props.order}
                                                                    onClick={(evt) => this.handleRequestSort(evt, index)}
                                                                >
                                                                    {column.name}
                                                                </TableSortLabel>
                                                            </Tooltip>
                                                        :
                                                        column
                                                }
                                            </TableCell>

                                        )
                                    })
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody
                          className={classes.body}
                          component={DroppableComponent}
                          id={'productDroppableComponent'}
                          onDragEnd={onDragEnd}
                        >
                            {this.props.areEntriesDraggable ?
                                  items.map((row, index) => {
                                        return (
                                            <TableRowComponent
                                                component={DraggableComponent}
                                                uuid={row.id}
                                                index={index}
                                                id={row.id}
                                                isClickable={this.props.clickableRows}
                                                key={index}
                                                row={row}
                                                handleRowSelect = {this.props.handleRowSelect}
                                            />
                                        )
                                    }
                                )
                                : this.props.rows.map((row, index) => {
                                  return (
                                    <TableRowComponent
                                      isClickable={this.props.clickableRows}
                                      key={index}
                                      row={row}
                                      handleRowSelect = {this.props.handleRowSelect}
                                    />
                                  )
                              })
                            }
                        </TableBody>
                    </Table>
                </MediaQuery>
                <Divider />
                {
                    this.props.hidePagination?
                        null
                        :
                        <Pagination
                            page={this.props.page}
                            totalRows={this.props.totalRows}
                            handlePageChange={this.props.handlePageChange}
                            rowsPerPage={this.props.rowsPerPage}
                            handleRowsPerPage={this.props.handleRowsPerPage}
                            colSpan={this.props.columns.length}
                        />
                }
            </div>
        )
    }
};

export default withStyles(styles)(TableComponent);


// WEBPACK FOOTER //
// ./src/components/General/table.js